import Decimal from "decimal.js";

/**
 * Decimal equivalents of Precise string operations.
 * These allow V2 methods to work directly with Decimal objects
 * instead of going through string → Precise → string → Decimal conversions.
 */

export function decimalAbs(value: Decimal | undefined): Decimal | undefined {
  if (value === undefined) return undefined;
  return value.abs();
}

export function decimalNeg(value: Decimal | undefined): Decimal | undefined {
  if (value === undefined) return undefined;
  return value.neg();
}

export function decimalLt(value: Decimal | undefined, other: Decimal.Value): boolean | undefined {
  if (value === undefined) return undefined;
  return value.lt(other);
}

export function decimalGt(value: Decimal | undefined, other: Decimal.Value): boolean | undefined {
  if (value === undefined) return undefined;
  return value.gt(other);
}

export function decimalEq(value: Decimal | undefined, other: Decimal.Value): boolean | undefined {
  if (value === undefined) return undefined;
  return value.eq(other);
}

export function decimalDiv(value: Decimal | undefined, divisor: Decimal | undefined): Decimal | undefined {
  if (value === undefined || divisor === undefined || divisor.isZero()) return undefined;
  return value.div(divisor);
}
